/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */

/**
 * 臨時経常区分
 */
export type SettlementStatisticsRevenuePatchRequestRecurringTypeValue =
  (typeof SettlementStatisticsRevenuePatchRequestRecurringTypeValue)[keyof typeof SettlementStatisticsRevenuePatchRequestRecurringTypeValue];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SettlementStatisticsRevenuePatchRequestRecurringTypeValue = {
  経常: '経常',
  臨時: '臨時',
} as const;
